import { nanoid } from 'nanoid/non-secure';

export function uniqID(length = 5) {
  return nanoid(length);
}
